import { BsFillStarFill,BsCalendar2Date } from 'react-icons/bs';
import useTrim from '../Hooks/useTrim';

const CardAlt = ({movie})=>{
    const {trimed} = useTrim((movie.title||movie.name),15);
    return <div className="flex flex-col justify-between md:h-48  md:p-2 p-2 shadow-md hover:scale-105 bg-background dark:bg-background-dark">
    <img alt="card poster" src={`https://image.tmdb.org/t/p/original${movie.backdrop_path||movie.poster_path}`} className='object-cover aspect-square min-h-[130px]'/>
    <h3 className="text-headline dark:text-headline-dark font-heading md:text-md text-xs ">{trimed}</h3>
    <span className="flex md:flex-row flex-col md:justify-between md:items-center justify-start text-headline dark:text-headline-dark md:text-md text-xs font-heading">
        {
            (movie.vote_average)?
            <h4 className="md:text-md text-xs mb-2 flex flex-row items-center"><BsFillStarFill className='text-[orange]'/>{movie.vote_average}</h4>
            :
            null
        }
        {
            (movie.release_date||movie.first_air_date||movie.air_date)?
            <h4 className="md:text-md text-xs flex flex-row items-center"><BsCalendar2Date/>{ ` ${movie.release_date||movie.first_air_date||movie.air_date}`}</h4>
            :
            null
        }
    </span>
</div>
}

export default CardAlt;